import { Overlay } from 'react-aria';
import { useRef, ReactNode, HTMLAttributes } from 'react';
import { Transition } from 'react-transition-group';

type SlideInMenuProps = {
  children: ReactNode;
  className?: string;
  isOpen: boolean;
  portalContainer?: Element | null;
} & HTMLAttributes<HTMLDivElement>;

const SlideInMenu = ({
  children,
  className,
  isOpen,
  portalContainer,
  ...props
}: SlideInMenuProps) => {
  const nodeRef = useRef<HTMLDivElement | null>(null);

  return (
    <Transition in={isOpen} nodeRef={nodeRef} timeout={300} unmountOnExit>
      {(s) => (
        <Overlay portalContainer={portalContainer || undefined}>
          <div
            {...props}
            ref={nodeRef}
            className={`transition lg:hidden ${className || ''} 
                            ${s === 'exited' || s === 'exiting' ? 'pointer-events-none translate-x-full' : ''}
                            ${s === 'entering' ? 'translate-x-0' : ''}`}
          >
            {children}
          </div>
        </Overlay>
      )}
    </Transition>
  );
};

export default SlideInMenu;
